export default class Freeform 
{
  
  constructor() 
  {
    this._freeform = document.querySelector(".jsFreeform");
    if (this._freeform) this.init();
  }

  init() 
  {
    this.lookForFreeformsToInit();
  }  

  lookForFreeformsToInit() 
  {

    // Find the form element
    const freeforms = document.getElementsByClassName("jsFreeform");

    // Attach on-ready listener
    // Be sure to do load this script before freeform JS initiates
    for (var i = 0; i < freeforms.length; i++)
    {

      freeforms[i].addEventListener('freeform-ready', function(event) 
      {
        const freeform = event.target.freeform;

        // Do something on a successful ajax submit
        freeform.addOnSuccessfulAjaxSubmit(function(event, form, response) {

          // Get the current page url
          let pageUrl = location.pathname + location.search;

          // Redirect the user
          if ( response.returnUrl && response.returnUrl != pageUrl )
          {
            window.location.href = response.returnUrl;
          }
        })        

        // Override the error and success message element class names
        freeform.setOption('errorClassBanner', 'form__error-banner');
        freeform.setOption('errorClassList', 'form__errors-list');
        freeform.setOption('errorClassField', 'form__field-has-errors');
        freeform.setOption('successClassBanner', 'form__success-banner');

        // Override the way those messages are removed
        /*freeform.setOption('removeMessages', function() {
          this.form.querySelectorAll('.form__error-banner').remove();
          this.form.querySelectorAll('.form__success-banner').remove();
          this.form.querySelectorAll('.form__error-list').remove();
        }); */

        // Override the way form submit success message is displayed
        freeform.setOption('renderSuccess', function() {

          // Retrieve/build the success message
          const successMessageCustom = this.form.querySelectorAll('.form__success');    

          if ( successMessageCustom.length )
          {
            // Retrieve and show the success message
            var successMessage = successMessageCustom[0];
            successMessage.classList.add('show');
          }
          else
          {
            // Build the default success message
            var successMessage = document.createElement("div");
            successMessage.classList.add("row"); 
            let successMessageWrapper = document.createElement("div");
            successMessageWrapper.classList.add("form__html", "medium-12", "columns");
            let successMessageContent = document.createElement("div");
            successMessageContent.classList.add("form__success", "show");
            let successMessageParagraph = document.createElement("p");
            successMessageParagraph.appendChild(document.createTextNode("Dank je!"));
            successMessageContent.appendChild(successMessageParagraph);
            successMessageWrapper.appendChild(successMessageContent);
            successMessage.appendChild(successMessageWrapper);
            this.form.querySelectorAll("[type=submit]")[0].parentNode.parentNode.parentNode.appendChild(successMessage);
          } 

          // Scroll to the success message
          // let successMessageOffset = offset(successMessage);
          let successMessageOffset = successMessage.getBoundingClientRect();
          if ( typeof(window.scroll) != "undefined" )
          {
            window.scroll({
              top: successMessageOffset.top + (window.scrollY - 100),
              left: 0,
              behavior: "smooth"
            });
          }

        });

        // Override the way form errors are displayed
        freeform.setOption('renderFormErrors', function(errors) {
          const errorBlock = document.createElement("div");
          errorBlock.classList.add("form__error-banner");

          const paragraph = document.createElement("p");
          paragraph.appendChild(document.createTextNode("Form contains errors!"));
          errorBlock.appendChild(paragraph);

          if (errors.length) {
            const errorsList = document.createElement("ul");
            for (let messageIndex = 0; messageIndex < errors.length; messageIndex++) {
              const message = errors[messageIndex];
              const listItem = document.createElement("li");

              listItem.appendChild(document.createTextNode(message));
              errorsList.appendChild(listItem);
            }

            errorBlock.appendChild(errorsList);
          }

          // this.form.insertBefore(errorBlock, this.form.childNodes[0]);
        });

        // Override the way field errors are displayed
        freeform.setOption('renderFieldErrors', function(errors) 
        {
          for (const key in errors) 
          {
            if (!errors.hasOwnProperty(key) || !key) 
            {
              continue;
            }

            const messages = errors[key];
            const errorsList = document.createElement("ul");
            errorsList.classList.add("form__error-list");

            for (let messageIndex = 0; messageIndex < messages.length; messageIndex++) 
            {
              const message = messages[messageIndex];
              const listItem = document.createElement("li");
              listItem.appendChild(document.createTextNode(message));
              errorsList.appendChild(listItem);
            }

            const inputList = this.form.querySelectorAll("*[name=" + key + "], *[name='" + key + "[]']");
            for (let inputIndex = 0; inputIndex < inputList.length; inputIndex++) 
            {
              const input = inputList[inputIndex];
              input.classList.add("form__field-has-errors");
              var form__errors = [].slice.call(input.parentElement.parentElement.children).filter(el=>el.className==='form__error');
              form__errors[0].appendChild(errorsList);
            }
          }

          const fieldsWithErrors = this.form.querySelectorAll(".form__field-has-errors");
          if ( fieldsWithErrors.length )
          {
            // let firstFieldOffset = offset(fieldsWithErrors[0]);
            let firstFieldOffset = fieldsWithErrors[0].getBoundingClientRect();
            if ( typeof(window.scroll) != "undefined" )
            {
              window.scroll({
                top: firstFieldOffset.top + (window.scrollY - 100),
                left: 0,
                behavior: "smooth"
              });
            }
          }    
        });

      });

    }
  }
}